// @flow
export const SET_SETTINGS = 'Settings/SET_SETTINGS';
export const CLEAR_SETTINGS = 'Settings/CLEAR_SETTINGS';


export function setSettings( settings ) {
    return {
        settings: settings,
        type: SET_SETTINGS
    };
}

export function clearSettings() {
    return {
        type: CLEAR_SETTINGS
    }
}